module.exports = {
	"name": "Logitech F310 (DirectInput) Firefox Windows",
	"supported": [
		{
			"id": "046d-c216-Logitech Dual Action",
			"os": "Windows NT",
			"browser": "Firefox"
		}
	],
	"axes": {
		"left stick x": {
			"index": 0
		},
		"left stick y": {
			"index": 1
		},
		"right stick y": {
			"index": 3
		},
		"right trigger": {
			"index": 5
		},
		"dpad x": {
			"index": 6
		},
		"dpad y": {
			"index": 7
		},
		"right stick x": {
			"index": 2
		}
	},
	"buttons": {
		"b": {
			"index": 2
		},
		"x": {
			"index": 0
		},
		"y": {
			"index": 3
		},
		"left shoulder": {
			"index": 4
		},
		"right shoulder": {
			"index": 5
		},
		"left stick": {
			"index": 10
		},
		"dpad left": {
			"index": 15
		},
		"dpad right": {
			"index": 16
		},
		"dpad up": {
			"index": 13
		},
		"dpad down": {
			"index": 14
		},
		"left stick right": {
			"axis": 0,
			"direction": 1
		},
		"left stick up": {
			"axis": 1,
			"direction": -1
		},
		"left stick left": {
			"axis": 0,
			"direction": -1
		},
		"left stick down": {
			"axis": 1,
			"direction": 1
		},
		"left trigger": {
			"index": 6
		},
		"right trigger": {
			"index": 7
		},
		"a": {
			"index": 1
		},
		"right stick": {
			"index": 11
		},
		"right stick right": {
			"axis": 2,
			"direction": 1
		},
		"right stick up": {
			"axis": 3,
			"direction": -1
		},
		"right stick down": {
			"axis": 3,
			"direction": 1
		},
		"right stick left": {
			"axis": 2,
			"direction": -1
		},
		"back": {
			"index": 8
		},
		"start": {
			"index": 9
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/html5-gamepad/mappings/logitechf310-directinput-ff-windows.json
// module id = 206
// module chunks = 0